import Star from "../../assets/images/star.png";
import LeftLine from "../../assets/images/pftoplineleft.png";
import RightLine from "../../assets/images/pftoplineright.png";
import Sun from "../../assets/images/sun.png";

const ProgramFlow = () => {
  return (
    <section className="w-full flex justify-center pt-[130px] sm:pt-[300px] md:pt-[350px] lg:pt-[450px] xl:pt-[590px] -mt-[160px] sm:-mt-[320px] md:-mt-[370px] lg:-mt-[450px] xl:-mt-[550px] pb-24 bg-[#EF7C61] relative">
      <img
        loading="lazy"
        className="absolute w-[60px] md:w-[100px] lg:w-[203px] -top-2 left-2 lg:-top-7 lg:left-5"
        src={LeftLine}
        alt="line"
      />
      <img
        loading="lazy"
        className="absolute w-[60px] md:w-[100px] lg:w-[203px] -top-2 right-2 lg:-top-7 lg:right-5"
        src={RightLine}
        alt="line"
      />
      <img
        loading="lazy"
        className="w-[50px] md:w-[70] lg:w-[110px] xl:w-[142px] absolute top-24 left-5 lg:top-[30rem] lg:left-10"
        src={Star}
        alt="star"
      />
      <div className="w-[112px] h-[112px] absolute lg:w-[352px] lg:h-[352px] right-0 top-1/4 xl:top-1/3 overflow-hidden">
        <img
          loading="lazy"
          className="animate-spin-slow absolute w-full -right-10 lg:-right-24 xl:-right-28"
          src={Sun}
          alt="sun"
        />
      </div>
      <div id="program-akisi" className="w-4/5 space-y-14 pt-14">
        <div>
          <h4 className="text-4xl lg:text-7xl text-center">
            <span
              style={{ fontFamily: "Gotham" }}
              className="text-[#FEF6E8] font-bold"
            >
              PROGRAM
            </span>
            <br />
            <span
              style={{ fontFamily: "Gotham" }}
              className="text-[#294B5B] font-bold"
            >
              AKIŞI
            </span>
          </h4>
        </div>
        <div className="flex flex-row w-full text-center">
          <div className="w-full lg:w-1/2 flex flex-col items-center space-y-3 lg:space-y-20 px-4 md:px-0">
            <div className=" w-full lg:w-[467px] font-bold text-xl lg:text-[54px] leading-none text-[#FEC343] bg-[url('../../assets/images/day1.png')] pt-4 pb-2 text-center bg-contain bg-center bg-no-repeat">
              <span
                style={{ fontFamily: "Gotham" }}
                className="whitespace-nowrap font-bold"
              >
                1. GÜN
              </span>
            </div>

            <ul
              style={{ fontFamily: "Poppins" }}
              className="w-full sm:w-3/5 xl:w-2/3 flex flex-col items-between text-[10px] lg:text-[25px] font-bold space-y-1 md:space-y-0"
            >
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white">10:00 - 10:30</span>
                <span className="text-[#294B5B]">Şirket Oturumu</span>
              </li>
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white float-left">10:40 - 11:10</span>
                <span className="text-[#294B5B] float-right">
                  Şirket Oturumu
                </span>
              </li>
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white float-left">11:20 - 11:50</span>
                <span className="text-[#294B5B] float-right">
                  Şirket Oturumu
                </span>
              </li>
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white float-left">12:00 - 12:30</span>
                <span className="text-[#294B5B] float-right">
                  Şirket Oturumu
                </span>
              </li>
            </ul>
            <div className="flex flex-col w-full items-center">
              <div className="relative font-bold text-[11px] lg:text-[34px] text-[#294B5B] bg-[url('../../assets/images/afternoon1.png')] bg-contain bg-center bg-no-repeat leading-none pt-4 pb-4  w-full lg:w-[468px] text-center">
                <span>ÖĞLE ARASI</span>
                <img
                  className="w-[19px] lg:w-[57px] absolute -left-1 bottom-2 lg:-left-5 lg:-bottom-4"
                  src={Star}
                  alt="star"
                />
              </div>
              <ul
                style={{ fontFamily: "Poppins" }}
                className="w-full sm:w-3/5 xl:w-2/3 flex flex-col items-between text-[10px] lg:text-[25px] font-bold space-y-1 md:space-y-0"
              >
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">13:00 - 13:30</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">13:40 - 14:10</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">14:20 - 14:50</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">15:00 - 15:30</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">15:40 - 16:10</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">16:20 - 16:50</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">17:00 - 17:30</span>
                  <span className="text-[#294B5B] float-right">Mt Paneli</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full lg:w-1/2 flex flex-col items-center space-y-3 lg:space-y-20 px-4 md:px-0">
            <div className=" w-full lg:w-[467px] font-bold text-xl lg:text-[54px] leading-none text-[#FEC343] bg-[url('../../assets/images/day2.png')] pt-4 pb-2 text-center bg-contain bg-center bg-no-repeat">
              <span
                style={{ fontFamily: "Gotham" }}
                className="whitespace-nowrap font-bold"
              >
                1. GÜN
              </span>
            </div>

            <ul
              style={{ fontFamily: "Poppins" }}
              className="w-full sm:w-3/5 xl:w-2/3 flex flex-col items-between text-[10px] lg:text-[25px] font-bold space-y-1 md:space-y-0"
            >
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white">10:00 - 10:30</span>
                <span className="text-[#294B5B]">Şirket Oturumu</span>
              </li>
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white float-left">10:40 - 11:10</span>
                <span className="text-[#294B5B] float-right">
                  Şirket Oturumu
                </span>
              </li>
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white float-left">11:20 - 11:50</span>
                <span className="text-[#294B5B] float-right">
                  Şirket Oturumu
                </span>
              </li>
              <li className="flex flex-col sm:flex-row justify-between">
                <span className="text-white float-left">12:00 - 12:30</span>
                <span className="text-[#294B5B] float-right">
                  Şirket Oturumu
                </span>
              </li>
            </ul>
            <div className="flex flex-col w-full items-center">
              <div className="relative font-bold text-[11px] lg:text-[34px] text-[#294B5B] bg-[url('../../assets/images/afternoon2.png')] bg-contain bg-center bg-no-repeat leading-none pt-4 pb-4  w-full lg:w-[468px] text-center">
                <span>ÖĞLE ARASI</span>
                <img
                  className="w-[19px] lg:w-[57px] absolute right-0 top-2 lg:right-0 lg:-top-9"
                  src={Star}
                  alt="star"
                />
              </div>
              <ul
                style={{ fontFamily: "Poppins" }}
                className="w-full sm:w-3/5 xl:w-2/3 flex flex-col items-between text-[10px] lg:text-[25px] font-bold space-y-1 md:space-y-0"
              >
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">13:00 - 13:30</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">13:40 - 14:10</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">14:20 - 14:50</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">15:00 - 15:30</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">15:40 - 16:10</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">16:20 - 16:50</span>
                  <span className="text-[#294B5B] float-right">
                    Şirket Oturumu
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span className="text-white float-left">17:00 - 17:30</span>
                  <span className="text-[#294B5B] float-right">
                    Stajyer Paneli
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ProgramFlow;
